var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 34.999,
    viewBox: "0 0 35 34.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clock",
    transform: "translate(-4.9 -4.901)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3967",
    "data-name": "Ellipse 3967",
    cx: 16.307,
    cy: 16.307,
    r: 16.307,
    transform: "translate(7.287 7.287)",
    fill: "#90d26d",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_292",
    "data-name": "Subtraction 292",
    d: "M16.731,33.466A16.733,16.733,0,1,1,33.467,16.731,16.752,16.752,0,0,1,16.731,33.466Zm0-32.262A15.527,15.527,0,1,0,32.259,16.731,15.545,15.545,0,0,0,16.731,1.2Z",
    transform: "translate(4.9 4.901)",
    fill: "#90d26d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14694",
    "data-name": "Path 14694",
    d: "M23.2,11.6a.5.5,0,0,1-.5-.5V9.754a.5.5,0,0,1,1.008,0V11.1A.5.5,0,0,1,23.2,11.6Zm0,25.539a.5.5,0,0,1-.5-.5V35.293a.5.5,0,1,1,1.008,0v1.344A.5.5,0,0,1,23.2,37.142ZM11.1,23.7H9.754a.5.5,0,0,1,0-1.008H11.1a.5.5,0,1,1,0,1.008Zm25.539,0H35.293a.5.5,0,1,1,0-1.008h1.344a.5.5,0,0,1,0,1.008ZM23.2,23.7a.5.5,0,0,1-.356-.148l-5.377-5.377a.5.5,0,1,1,.713-.713l5.02,5.02,7.709-7.709a.5.5,0,1,1,.713.713l-8.065,8.065A.505.505,0,0,1,23.2,23.7Z",
    transform: "translate(-1.562 -1.562)",
    fill: "#90d26d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3968",
    "data-name": "Ellipse 3968",
    cx: 1.165,
    cy: 1.165,
    r: 1.165,
    transform: "translate(20.469 20.468)",
    fill: "#e9f6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14695",
    "data-name": "Path 14695",
    d: "M29.1,30.946A1.848,1.848,0,1,1,30.946,29.1,1.85,1.85,0,0,1,29.1,30.946Zm0-2.688a.84.84,0,1,0,.84.84A.841.841,0,0,0,29.1,28.258Z",
    transform: "translate(-7.465 -7.465)",
    fill: "#90d26d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/Clock_icon.a7db3745b6849b071f213794233c12a9.svg";
export { ForwardRef as ReactComponent };